import { render, staticRenderFns } from "./KisCommitteeList.vue?vue&type=template&id=1ab99968"
import script from "./KisCommitteeList.js?vue&type=script&lang=js&external"
export * from "./KisCommitteeList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports